<template>
  <div id="app" ref="app">
    <section>
      <div class="logo">
        <img src="https://app.hebitv.com/assets/v2/img/UserCenter_Logo_hebi.png" />
        <p>当前版本 {{ city.version }}</p>
      </div>
      <ul class="more-info">
        <li v-if="city.website">
          <img src="@/assets/images/system/about/personal_icon_web.png" />
          <span class="text">官方网站：</span>
          <!-- <a class="address" @click="onclick(`http://${city.website}`)">{{city.website}}</a> -->
          <a class="address" href="javascript:;">{{ city.website }}</a>
        </li>
        <li v-if="city.wechat">
          <img src="@/assets/images/system/about/personal_icon_weixin.png" />
          <span class="text">微信公众号：</span>
          <span>{{ city.wechat }}</span>
        </li>
        <li v-if="city.tel">
          <img src="@/assets/images/system/about/personal_icon_phone.png" />
          <span class="text">客服电话：</span>
          <a @click="onDial(`${city.tel}`)">{{ city.tel }}</a>
        </li>
        <li v-if="city.cooperation">
          <img src="@/assets/images/system/about/cooperation.png" />
          <span class="text">商务合作：</span>
          <a @click="onDial(`${city.cooperation}`)">{{ city.cooperation }}</a>
        </li>
        <li>
          <!-- <img src="@/assets/images/system/about/cooperation.png" /> -->
          <span class="text">APP备案号：豫ICP备05017900号-3A</span>
        </li>
        <li>
          <span class="text">互联网新闻许可证：41120180010</span>
        </li>
      </ul>
      <div class="code" v-if="city.qrcode.url">
        <img src="@/assets/images/system/about/code.jpg" />
        <p>扫描二维码</p>
        <p>{{ city.qrcode.text }}</p>
      </div>
      <div class="code app" v-if="city.app.url">
        <img :src="city.app.url" />
        <p v-html="city.app.text"></p>
      </div>
      <footer>
        <p v-for="(item, index) in city.footer" :key="index" v-html="item"></p>
      </footer>
    </section>
  </div>
</template>

<script>
// import { palauDispatch, qs } from '../js/index'

export default {
  name: 'app',
  data() {
    var isInClient = typeof SZJSBridge !== 'undefined'
    const clientId = process.env.VUE_APP_CLIENT_ID
    var versionNum = '5.0.0'
    if (isInClient) {
      versionNum = window.PalauAPI.browser.userAgent().match(/(\s)Client\/(\S+)/)[2]
    }
    return {
      env: process.env.NODE_ENV,
      clientIds: clientId,
      city: {
        version: `V${versionNum}`,
        website: 'www.hebitv.com',
        wechat: '鹤壁融媒',
        tel: '18839275358',
        cooperation: '',
        qrcode: {
          url: '/app/static/imgs/code.jpg',
          text: '关注鹤壁融媒'
        },
        app: {},
        footer: ['鹤壁市融媒体中心（鹤壁市广播电视台）版权所有', 'Copyright © 鹤壁市融媒体中心（鹤壁市广播电视台）']
      }
    }
  },
  components: {},
  mounted() {
    document.title = '关于我们'
    window.SZJSBridge.view.toggleShareBtn(0)
    const clientheight = document.documentElement.clientHeight
    const logo = document.querySelector('.logo').clientHeight
    const moreInfo = document.querySelector('.more-info').clientHeight
    const code = document.querySelector('.code').clientHeight
    const footer = document.querySelector('footer').clientHeight
    const height = logo + moreInfo + code * 2 + footer + 82
    if (clientheight < height) {
      document.querySelector('footer').style.marginTop = '32px'
      document.querySelector('footer').style.marginBottom = '8px'
      document.querySelector('footer').style.position = 'static'
    }
  },
  methods: {
    onclick(value) {
      window.PalauAPI.dispatch(value)
    },
    onDial(value) {
      window.PalauAPI.device.dial(value)
    }
  }
}
</script>
<style lang="stylus">
.address {
  color: #333 !important;
  text-decoration: none !important;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.logo,
.code {
  text-align: center;
}
.logo {
  margin-bottom: 28px;
  margin-top: 40px;
}
.logo img {
  width: 216px;
  height: 216px;
  margin-bottom: 26px;
}
.more-info {
  margin-bottom: 14px;
}
.more-info li {
  display: flex;
  justify-content: flex-start;
}
.logo p {
  color: #959595;
  font-size: 30px;
}
.linyiinfo {
  width: 100%;
  overflow: auto;
  padding: 26px 30px;
}
.linyiinfo p {
  color: #959595;
  font-size: 30px;
  text-align: left;
}
.kunshaninfo {
  width: 100%;
  overflow: auto;
  padding: 26px 30px;
}
.kunshaninfo p {
  color: #959595;
  font-size: 30px;
  text-align: center;
}
.code img {
  width: 235px;
  height: 235px;
}
.code p {
  font-size: 30px;
}
.app {
  margin-top: 70px;
}
li * {
  float: left;
}
li {
  font-size: 28px;
  padding-left: 104px;
  height: 76px;
  line-height: 76px;
}
li a {
  color: #009eff;
}
li span {
  font-weight: bold;
  font-size: 30px;
}
li .text {
  font-weight: normal;
}
li img {
  vertical-align: middle;
  width: 42px;
  height: 42px;
  margin-top: 18px;
  margin-right: 16px;
}
p {
  text-align: center;
}
footer {
  position: fixed;
  bottom: 16px;
  text-align: center;
  width: 100%;
}
footer p {
  font-size: 18px;
  line-height: 26px;
  color: #d6d6d6;
  padding: 0 30px;
}
</style>
